<script>
    import {onMount, onDestroy} from "svelte";    
    import Details from './reportdetails.svelte'; 

    let importDetails;
    let exportDetails;
    
    onMount(async()=>{
        jQuery(".container").css("max-width","none");
        await importDetails.getImportData();
    })

    onDestroy(()=>{
        jQuery(".container").css("max-width","");
    })

</script>

<svelte:head>
    <title>Reports | Wavenet Nimbus </title>
</svelte:head>

<h1>Reports</h1>
<div>
    <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#sub1" on:click|preventDefault={async()=>{await importDetails.getImportData()}}>Import</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#sub2" on:click|preventDefault={async()=>{await exportDetails.getExportData()}}>Export</a>
        </li>
        <!-- <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#sub3">Export MS</a>
        </li> -->
    </ul>

    <div class="tab-content">
        <div class="tab-pane active" id="sub1">
            <Details bind:this={importDetails}/>               
        </div>
        <div class="tab-pane" id="sub2">
            <Details bind:this={exportDetails} detailsFor="export"/>                                          
        </div>          
    </div>
</div>
